/**
 * صياغةُ الأرقام والتواريخ — <b>في مكانٍ واحد، ولكلّ التطبيقات</b>.
 *
 * ⚠ وليس هنا اسمُ حالةٍ ولا رمزُ مستند: تلك أسماءُ **مجال** يخصّ تطبيقًا بعينه
 *   (حالاتُ المسوّدة في الإدارة، وحالاتُ البيع في نقطة البيع)، ومكانُها
 *   التطبيق. وحزمةٌ مشتركةٌ تبتلع أسماءَ كلّ مجالٍ تصير مكبًّا — وهذا هو الحدُّ
 *   الذي وضعه المالكُ لها بالضبط.
 *
 * والأرقامُ لاتينيّةٌ في كلّ شاشة (`ar-JO-u-nu-latn`): الموظّفُ يقرأ سعرًا من
 * الشاشة ويكتبه على الفاتورة وفي الواتساب، والمصفوفةُ الهنديّة تختلط عليه بين
 * ٦ و٧، وتُنسخ خطأً إلى أنظمةٍ لا تقرؤها. القرارُ هنا وحدَه، لا في كلّ مكوّن.
 */

const money = new Intl.NumberFormat('ar-JO-u-nu-latn', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 3,
})

const quantity = new Intl.NumberFormat('ar-JO-u-nu-latn', {
  maximumFractionDigits: 3,
})

const moment = new Intl.DateTimeFormat('ar-JO-u-nu-latn', {
  dateStyle: 'short',
  timeStyle: 'short',
})

/** مبلغٌ ومعه عملتُه — و«—» حين لا قيمةَ أصلًا. */
export function formatMoney(value: number | null | undefined, currency = 'JOD') {
  // ⚠ لا `!value`: صفرٌ قيمةٌ صحيحةٌ وتختلف عن الفراغ. كلفةٌ صفريّةٌ تُعرض
  // «—» تُقرأ «لم تُدخل بعد»، وهي في الحقيقة «أُدخلت صفرًا» — وبين
  // القراءتين قرارُ جردٍ مختلف.
  return value === null || value === undefined ? '—' : `${money.format(value)} ${currency}`
}

export function formatQty(value: number | null | undefined) {
  return value === null || value === undefined ? '—' : quantity.format(value)
}

export function formatMoment(value: string | null | undefined) {
  return value ? moment.format(new Date(value)) : '—'
}

/**
 * يحوّل ما كُتب إلى رقم — و`null` حين لا يُقرأ، <b>فلا يُرسل «صفرٌ» لم يقصده أحد</b>.
 *
 * والأرقامُ العربيّةُ الشرقيّة تُقرأ هنا، وكذلك الفاصلةُ «٫» والفاصلةُ العربيّة
 * «،»: هذا ما تُخرجه لوحةُ المفاتيح العربيّة على الهاتف، و`Number('١٠')`
 * يردّ `NaN`. فبلا هذا التطبيعِ تصير كميّةٌ كتبها الموظّفُ بالعربيّة فراغًا.
 */
export function toNumber(text: string): number | null {
  const normalized = text
    .trim()
    .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
    .replace(/[٫،]/g, '.')

  if (normalized === '') {
    return null
  }

  const value = Number(normalized)

  return Number.isFinite(value) ? value : null
}
